module.exports = __webpack_public_path__ + "img/l-10.e0b0ad88.png";